import { Text } from '@dixa/lib-shared-habla';
import { ConversationAutomationConditionLogEntry } from 'lib-shared-types-api';

type RoutedThroughConditionProps = {
  node: ConversationAutomationConditionLogEntry;
};

export function RoutedThroughCondition({
  node: { is_matching: isMatching },
}: RoutedThroughConditionProps): JSX.Element {
  return (
    <Text.Paragraph>
      Condition · {isMatching ? 'Match' : 'No match'}
    </Text.Paragraph>
  );
}
